import { Component, OnInit, Input, forwardRef, SimpleChanges } from '@angular/core';
import { 
    IonSpinner, ToastController
} from '@ionic/angular/standalone';
import { TranslateService } from '@ngx-translate/core';

import { MarvDateService } from '@marv/services';
import { MissionAdditionalDataComponent, MissionDetails } from '@app/components';
import { OperationService, OrderService } from '@app/services';
import { OperationCard } from '@app/models';

@Component({
    selector: 'app-mission-details-additional-data',
    templateUrl: './additional-data.component.html',
    styleUrls: ['./additional-data.component.scss'],
    imports: [IonSpinner, forwardRef(() => MissionAdditionalDataComponent)]
})
export class MissionDetailsAdditionalDataComponent  implements OnInit {

    @Input({alias : 'mission', required : true}) missionDetails: MissionDetails;

    isFetching: boolean = false;
    canEdit: boolean = false;
    opCocaVitrine: OperationCard|null = null;
    additionalsDatas: any = null;
    
    constructor(
        private toastController: ToastController,
        public translateService: TranslateService,
        private orderService: OrderService
    ) { }

    async ngOnInit() {
        // A MODIFIER - Ajout de la saisie des vitrines en dur
        if(this.missionDetails){
            let today = MarvDateService.GetToday();
            this.canEdit = (this.missionDetails.activitySelected && this.missionDetails.activitySelected.day >= today ? true : false);            
            this.opCocaVitrine = OperationService.Operations.find(o => o.id === this.missionDetails.operation?.id && this.missionDetails.operation?.id === 2028) || null;   
            if(this.opCocaVitrine !== null){
                await this.loadAdditionalsDatas();
            }
        }
    }
    
    async loadAdditionalsDatas() {
        this.isFetching = true;
        this.additionalsDatas = await this.orderService.loadAdditionalsDatas(this.missionDetails.missionId); 
        this.isFetching = false;
    }
    
    async onChangeAdditionalsDatas(data: any){
        if(data !== null){
            let statutSave = await this.orderService.saveAdditionalsDatas(this.missionDetails.missionId, data);
            if(statutSave){
                await this.loadAdditionalsDatas();
                const toast = await this.toastController.create({
                    message: this.translateService.instant('MSG_SUCCESS_SAVE_ADDITIONALS_DATAS'),
                    duration: 6000,
                    position: 'top',
                    color: 'success'
                });
                await toast.present();
            }
            else{
                const toast = await this.toastController.create({
                    message: this.translateService.instant('MSG_ERROR_SAVE_ADDITIONALS_DATAS'),
                    duration: 6000,
                    position: 'top',
                    color: 'danger'
                });
                await toast.present();
            }
        }
    }
}
